<glxy-table-container
  [columns]="columns"
  [dataSource]="dataSource"
  [pageSizeOptions]="[10, 25, 100]"
  [pageSize]="25"
  [border]="true"
>
  <glxy-table-content-header
    [showFilters]="!isForcedFilteredView()"
    [showFiltersOpen]="true"
    [showSort]="false"
    [showSearch]="false"
  >
    <div filters-area>
      <glxy-filter-chips
        (filtersChanged)="onFilterChanged($event)"
        [showAddFilter]="noFiltersApplied()"
      ></glxy-filter-chips>
    </div>
  </glxy-table-content-header>

  <table mat-table>
    <tr mat-header-row *matHeaderRowDef="[]"></tr>
    <tr mat-row *matRowDef="let row; columns: []" class="clickable-row" (click)="onRowClicked(row)"></tr>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef class="description-col" class="left-align">
        {{ 'DISPUTES.TABLE.COLUMN_HEADERS.DESCRIPTION' | translate }}
      </th>
      <td mat-cell *matCellDef="let dispute" class="description-col" class="left-align">
        @if (canClickPaymentReference()) {
          <a (click)="paymentReferenceClickEvent($event, dispute)" class="description">
            @if (dispute.referenceType === PaymentReferenceType.RETAIL_PAYMENT_REFERENCE_TYPE_INVOICE) {
              <span>{{ dispute.description | padInvoiceNumber }}</span>
            } @else {
              <span>{{ dispute.description }}</span>
            }
          </a>
        } @else {
          <span>
            @if (dispute.referenceType === PaymentReferenceType.RETAIL_PAYMENT_REFERENCE_TYPE_INVOICE) {
              <span>{{ dispute.description | padInvoiceNumber }}</span>
            } @else {
              <span>{{ dispute.description }}</span>
            }
          </span>
        }
        @switch (dispute.referenceType) {
          @case (PaymentReferenceType.RETAIL_PAYMENT_REFERENCE_TYPE_INVOICE) {
            <div class="secondary-text">
              {{ 'PAYMENTS_PAGE.INVOICE' | translate }}
            </div>
          }
          @case (PaymentReferenceType.RETAIL_PAYMENT_REFERENCE_TYPE_SALES_ORDER) {
            <div class="secondary-text">
              {{ 'PAYMENTS_PAGE.ORDER' | translate }}
            </div>
          }
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="customerId">
      <th mat-header-cell *matHeaderCellDef class="customer-col" class="left-align">
        {{ customerTitleTranslationKey() | translate }}
      </th>
      <td mat-cell *matCellDef="let dispute" class="customer-col" class="left-align">
        <a (click)="customerClickEvent($event, dispute.customerId)">
          <span>{{ dispute.customerName || dispute.customerId }}</span>
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'DISPUTES.TABLE.COLUMN_HEADERS.CREATED' | translate }}
      </th>
      <td mat-cell *matCellDef="let dispute">
        <div>
          {{ dispute.created ? (dispute.created | glxyDate) : '' }}
        </div>
        <span class="secondary-text">
          {{ dispute.created ? (dispute.created | glxyDate: DateFormat.shortTime) : '' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="due">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'DISPUTES.TABLE.COLUMN_HEADERS.RESPONSE_DUE' | translate }}
      </th>
      <td mat-cell *matCellDef="let dispute">
        <div>
          {{ dispute.evidenceDetails.dueBy ? (dispute.evidenceDetails.dueBy | glxyDate) : '' }}
        </div>
        <span class="secondary-text">
          {{ dispute.evidenceDetails.dueBy ? (dispute.evidenceDetails.dueBy | glxyDate: DateFormat.shortTime) : '' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'DISPUTES.TABLE.COLUMN_HEADERS.STATUS' | translate }}
      </th>
      <td mat-cell *matCellDef="let dispute">
        <smb-invoicing-payment-status-chip
          [status]="dispute.status"
          [disputeResponseDue]="dispute?.evidenceDetails?.dueBy"
        ></smb-invoicing-payment-status-chip>
      </td>
    </ng-container>

    <ng-container matColumnDef="resolvedAt">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'DISPUTES.TABLE.COLUMN_HEADERS.RESOLVED' | translate }}
      </th>
      <td mat-cell *matCellDef="let dispute">
        <div>
          {{ dispute.resolvedAt ? (dispute.resolvedAt | glxyDate) : '' }}
        </div>
        <span class="secondary-text">
          {{ dispute.resolvedAt ? (dispute.resolvedAt | glxyDate: DateFormat.shortTime) : '' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="reason">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'DISPUTES.TABLE.COLUMN_HEADERS.REASON' | translate }}
      </th>
      <td mat-cell *matCellDef="let dispute">
        {{ dispute.reason | disputeReasonDisplay | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef class="right-align">
        {{ 'DISPUTES.TABLE.COLUMN_HEADERS.AMOUNT' | translate }}
      </th>
      <td mat-cell *matCellDef="let dispute" class="right-align">
        {{ dispute.amount | price: dispute.currencyCode }}
      </td>
    </ng-container>
  </table>
</glxy-table-container>
